<template>
  <md-button
    v-if="errorState !== 'NO_ERRORS' && errorState !== 'UNINITIALIZED'"
    class="save-button save-anyway-button"
    :disabled="disabled"
    @click="save"
  >
    <md-icon v-if="saving">
      refresh
    </md-icon>
    <md-icon v-if="errorState === 'ERRORS_SAVED'">
      save
    </md-icon>
    {{ buttonLabel }}
  </md-button>
  <div
    v-else
    class="save-button save-no-errors"
    :class="{ 'dark-colors': dark }"
  >
    <div v-if="saving">
      <md-icon>
        refresh
      </md-icon>
      Saving
    </div>
    <div v-else>
      <md-icon>
        save
      </md-icon>
      {{ isNew ? 'New' : 'Saved!' }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'save-button',
  props: {
    saving: {
      type: Boolean,
      required: true,
    },
    errorState: {
      type: String,
      required: true,
    },
    isNew: {
      type: Boolean,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    dark: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    buttonLabel() {
      if (this.errorState === 'ERRORS_NOT_SAVED') {
        return 'Save Anyway';
      }
      return this.saving ? 'Saving' : 'Saved!';
    }
  },
  methods: {
    save() {
      if (this.errorState === 'ERRORS_NOT_SAVED') {
        this.$emit('save', true);
      }
    },
  }
}
</script>

<style scoped>
.save-button {
  width: 115px;
  height: 40px;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  margin: 0 4px;
  font-size: 15px;
  font-weight: 500;
  border-radius: 50px;
}

.save-anyway-button {
  background-color: #F2994A !important;
  color: white !important;
}

.save-anyway-button .md-icon {
  color: white;
}

.save-no-errors {
  color: #0C70B0;
}

.save-no-errors .md-icon {
  color: #0C70B0 !important;
}

.save-no-errors.dark-colors {
  color: white !important;
}

.save-no-errors.dark-colors .md-icon {
  color: white !important;
}
</style>